module.exports = __webpack_public_path__ + "img/welcome-widget-guru.d022a262.png";